import Icon from "@mui/material/Icon";

// Builds the sidenav/route tree (with rendered icon elements) from the flat
// menu array returned by the HRMS login API. Used both right after login and
// when rehydrating the session from persisted storage on app load, so the
// route tree is always regenerated fresh (icon elements can't survive a
// JSON round-trip).
export function transformMenuData(data) {
  const result = [];
  const groupedMap = new Map();

  (data || []).forEach((item) => {
    const {
      mainMenuId,
      mainMenu,
      subMenuId,
      subMenuName,
      eouRoutingPath,
      type,
      menuKey,
      icon,
      component,
    } = item;

    if (!groupedMap.has(mainMenuId)) {
      groupedMap.set(mainMenuId, {
        mainMenuId,
        mainMenu,
        children: [],
      });
    }

    groupedMap.get(mainMenuId).children.push({
      subMenuId,
      subMenuName,
      eouRoutingPath,
      type,
      menuKey,
      icon,
      component,
    });
  });

  groupedMap.forEach((group) => {
    if (group.children.length === 1) {
      const child = group.children[0];
      result.push({
        type: "collapse",
        name: group.mainMenu,
        key: child.menuKey,
        route: child.eouRoutingPath,
        icon: <Icon fontSize="small">{child.icon}</Icon>,
        component: child.component,
      });
    } else {
      result.push({
        type: "dropdown",
        name: group.mainMenu,
        key: group.mainMenu.toLowerCase().replace(/\s+/g, "-"),
        icon: <Icon fontSize="small">{group.children[0].icon}</Icon>,
        collapse: [
          {
            type: "collapse",
            name: group.mainMenu,
            key: group.mainMenu.toLowerCase().replace(/\s+/g, "-"),
            collapse: group.children.map((child) => ({
              type: "collapse",
              name: child.subMenuName,
              key: child.menuKey,
              route: child.eouRoutingPath,
              icon: <Icon fontSize="small">{child.icon}</Icon>,
              component: child.component,
            })),
          },
        ],
      });
    }
  });

  return result;
}
